import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { PartnerDomainPanelProps } from './types';
import { styles } from './styles';
import { Button, CollapsiblePanel } from '@v2/components';
import PartnerDomain from '../PartnerDomain';

const PartnerDomainPanel: React.FC<PartnerDomainPanelProps> = ({
  domains,
  handleAddDomain,
  handleDeleteDomain,
}) => {

  return (
    <CollapsiblePanel title="Domains" defaultExpanded={false}>
      <div className={styles.header}>
        <span className={styles.title}>
          {
            domains.length > 0 ? `${domains.length} ${domains.length === 1 ? 'domain' : 'domains'}` : 'No domains for this partner'
          }
        </span>
        <Button
          variant="ghost-success"
          size="sm"
          onClick={handleAddDomain}
          icon={<FontAwesomeIcon icon={faPlus} />}
        >
          Add Domain
        </Button>
      </div>
      {domains.length > 0 && (
        <div className={styles.grid}>
          {domains.map((domain) => (
            <PartnerDomain
              key={domain.id}
              domain={domain}
              onDelete={handleDeleteDomain}
            />
          ))}
        </div>
      )}
    </CollapsiblePanel>
  );
};

export default PartnerDomainPanel;
